'use strict';

const _ = require('lodash');
const Backbone = require('backbone');
const Marionette = require('backbone.marionette');

const extend = Backbone.Model.extend;

const mixin = function (protoProps, classProps) {
    const parent = this;

    const mixins = protoProps.mixins;
    if (mixins) {
        const mixinMethods = _.values(mixins);
        const protoConstructor = (_.has(protoProps, 'constructor') ? protoProps.constructor : null);
        protoProps = _.defaults.apply(null, [{}, protoProps].concat(mixinMethods));
        protoProps.mixins = _.create(parent.prototype.mixins, mixins);

        protoProps.constructor = function () {
            const me = this; const
                args = arguments;

            _.each(mixinMethods, function (mixin) {
                if (mixin.beforeConstruction) {
                    mixin.beforeConstruction.apply(me, args);
                }
            });

            let result;
            if (protoConstructor) {
                result = protoConstructor.apply(me, args);
            } else {
                result = parent.apply(me, args);
            }

            _.each(mixinMethods, function (mixin) {
                if (mixin.afterConstruction) {
                    mixin.afterConstruction.apply(me, args);
                }
            });

            return result;
        };
    }
    protoProps.__parent = this;

    return extend.call(parent, protoProps, classProps);
};

_.each([
    Backbone.Model,
    Backbone.Collection,
    Backbone.Router,
    Marionette.View,
    Marionette.ItemView,
    Marionette.LayoutView,
    Marionette.CollectionView,
    Marionette.CompositeView,
    Marionette.Object
], function (klass) {
    klass.mixin = mixin;
});
